export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_LOADED = 'PAGE_LOADED';

export const pageLoading = () => ({ type: PAGE_LOADING });

export const pageLoaded = () => ({ type: PAGE_LOADED });
